import { AnimatePresence } from "motion/react";
import TargetMenu from "@/domains/targetMenu/components/TargetMenu";
import useTargetMenu from "@/domains/targetMenu/hooks/useTargetMenu";
import { IS_DEV } from "@/domains/main/constants/other";

function TargetMenuContainer() {
  const { changeItems, handleClick, handleClose, nestedItems, menuItems, menu } = useTargetMenu();

  return (
    <AnimatePresence>
      {!menu && !IS_DEV ? null : (
        <TargetMenu
          items={menuItems}
          isNestedItems={!!nestedItems}
          onClose={handleClose}
          onClick={handleClick}
          onChangeItems={changeItems}
        />
      )}
    </AnimatePresence>
  );
}

export default TargetMenuContainer;
